import styles from '../ActivityDropDown.module.scss'
import cx from 'classnames'
import { useRef } from 'react'
import { isElementInViewport } from '../../../utils'
import ActivityMultiSelect from './ActivityMultiSelect'
import PropTypes from 'prop-types'

export default function ActivityDropDown({
  items,
  placeholder,
  isActive,
  activityType,
  queryName,
}) {
  const ref = useRef()

  const handleMenuOpen = () => {
    const dropdown = ref.current

    if(dropdown && !isElementInViewport(dropdown)) {
      dropdown.classList.add(styles.rightAlignDropDown)
    }
  }
  return (
    <div
      className={cx(styles.filterContainer, styles.filter, {
        [styles.active]: isActive,
      })}
      tabIndex={1}
      onFocus={handleMenuOpen}
    >
      {placeholder}
      <i
        className={cx(
          styles.dropDownIcon,
          'dsl-icons dsl-icons--arrow-dropdown',
        )}
      />
      <ActivityMultiSelect
        activityType={activityType}
        items={items}
        ref={ref}
        filterHeader={placeholder}
        queryName={queryName}
      />
    </div>
  )
}

ActivityDropDown.propTypes = {
  items: PropTypes.array,
  placeholder: PropTypes.string,
  isActive: PropTypes.bool,
  activityType: PropTypes.string,
  queryName: PropTypes.string,
}
